/**
 * Application Messages Constants
 * 
 * Centralized location for all user-facing messages to avoid magic strings.
 * This improves maintainability, consistency, and makes internationalization easier in the future.
 * 
 * @remarks
 * ## Performance Considerations
 * 
 * ### Bundle Size & Tree-Shaking
 * - Angular 16+ with esbuild/Webpack provides excellent tree-shaking
 * - String constants are lightweight (~5-10 KB for 100 messages)
 * - The entire MESSAGES object will be included in the bundle when imported
 * - This is acceptable for small to medium-scale applications
 * 
 * ### Scaling Guidelines
 * - **< 200 messages**: Keep in a single file (current approach) ✅
 * - **200-500 messages**: Consider splitting by domain/feature
 * - **> 500 messages**: Definitely split into separate files per module
 * 
 * ### Runtime Performance
 * - No runtime performance impact (constants resolved at compile time)
 * - No memory overhead (primitive string values)
 * 
 * ## Refactoring Strategy (if needed in the future)
 * 
 * If this file grows too large, consider splitting by domain:
 * 
 * @example
 * ```typescript
 * // messages/file-downloader.messages.ts
 * export const FILE_DOWNLOADER_MESSAGES = { ... } as const;
 * 
 * // messages/cart.messages.ts
 * export const CART_MESSAGES = { ... } as const;
 * 
 * // messages/index.ts
 * export const MESSAGES = {
 *   FILE_DOWNLOADER: FILE_DOWNLOADER_MESSAGES,
 *   CART: CART_MESSAGES,
 * } as const;
 * ```
 * 
 * This maintains backward compatibility while improving organization.
 * 
 * @see https://angular.io/guide/build#configuring-commonjs-dependencies
 */
export const MESSAGES = {
    /**
     * File downloader messages
     */
    FILE_DOWNLOADER: {
        DOCUMENT_NOT_AVAILABLE: 'Documento no disponible en éste momento',
        DOWNLOAD_ERROR: 'Error trying to download file.',
    },
} as const;
